/**
 * @generated SignedSource<<877c3266965fe0c6490a1a9a7c3a0f7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type BreadcrumbForHolderPrefecture_post$data = {
  readonly slug: string
  readonly h1: string
  readonly holder_prefecture: {
    readonly name: string
    readonly roma: string
  } | null
  readonly ' $fragmentType': 'BreadcrumbForHolderPrefecture_post'
}
export type BreadcrumbForHolderPrefecture_post$key = {
  readonly ' $data'?: BreadcrumbForHolderPrefecture_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'BreadcrumbForHolderPrefecture_post'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'BreadcrumbForHolderPrefecture_post',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      concreteType: 'HolderPrefecture',
      kind: 'LinkedField',
      name: 'holder_prefecture',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'name',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'roma',
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'Post',
  abstractKey: null
}

;(node as any).hash = 'e89fc943c83911b25b854a3e1e0a3934'

export default node
